import { message } from 'antd';
export const baseInfo = {
  "id": '',
  "order_no": "",
  "status": '',
  "base_info": {
    "container_no": "",
    "arrival_time": "",
    "temperature": '',
    "car_number": "",
    "car_type": "",
    "address_id": '',
    "address": "",
    "amount": '',
    "warehouse_name": "",
    "warehouse_phone": "",
    "finance_name": "",
    "finance_phone": "",
    "car_number_pic": [],
    "driver_license": '',
    "driver_license_pic": [],
    "driver_name": '',
    "driver_number": '',
    "warehouse_position": '',
    "finance_position": '',
    "sales_name": '',
    "sales_phone": '',
    "sales_position": '',
    "quality_time": '',
  },
  "container_info": {
    "container_time": "",
    "container_pic": [],
    "outlet_temperature": '',
    "outlet_temperature_pic": [],
    "return_air_temperature": '',
    "return_air_temperature_pic": [],
    "air_temperature_pic": [],//风口温度
    "box_in_temperature": '',
    "box_in_temperature_pic": [],
    "core_temperature": '',
    "core_temperature_pic": [],
    "container_taste": '',
    "container_taste_desc": '',
    "box_in_humidity": '',
    "box_in_humidity_pic": '',
    "carton_condition_type": '',
    "carton_condition_number": '',
    "carton_condition_number_pic": [],
    "carton_condition_number_video": [],
    "air_temperature": '',
    "container_temperature_head": '',
    "container_temperature_head_pic": [],
    "container_temperature_middle": '',
    "container_temperature_middle_pic": [],
    "container_temperature_end": '',
    "container_temperature_end_pic": [],
    "container_temperature_average": '',
    "core_temperature1": '',
    "core_temperature1_pic": [],
    "core_temperature2": '',
    "core_temperature2_pic": [],
    "core_temperature3": '',
    "core_temperature3_pic": [],
    "core_temperature_average": '',
    "IOT1_no": '',
    "IOT1_no_temperature": '',
    "IOT1_no_temperature_pic": [],
    "IOT2_no": '',
    "IOT2_no_temperature": '',
    "IOT2_no_temperature_pic": [],
    "IOT3_no": '',
    "IOT3_no_temperature": '',
    "IOT3_no_temperature_pic": [],
  },
  "sample_info": {
    "sample_number": '',
    "sample_pic": [],
    "total_number": '',
    "product_info": [
      {
        "sale_id": '',
        "sample_number": ''
      }
    ]
  },
  "carton_packaging": {
    "carton_packaging_sticker_pic": []//纸箱包装贴纸
  },
  "fruit_handle": {
    "fruit_handle_sticker_pic": []//果把贴码
  },
  "weight_info": {
    "weight_pic": [],
    "average_weight": '',
    "package_weight": '',
    "deviation": '',
    "is_standard": ''
  },
  "fruit_shape": {
    "poor_fruit_shape": '',
    "poor_fruit_shape_number": '',
    "poor_fruit_shape_number_pic": [],
    "poor_fruit_shape_describe": '',//果形描述
    "fruit_house": '',
    "fruit_house_number": '',
    "fruit_house_shape_number_pic": [],
    "fruit_house_number_3": '',
    "fruit_house_number_3_pic": [],
    "fruit_house_number_35": '',
    "fruit_house_number_35_pic": [],
    "fruit_house_number_4": '',
    "fruit_house_number_4_pic": [],
    "poor_fruit_shape_number_percent": ''
  },
  "fruit_stalk": {//果柄
    "fruit_stalk_type": '',
    "fruit_stalk_broken": '',
    "fruit_stalk_broken_pic": [],
    "fruit_stalk_lacking": '',
    "fruit_stalk_lacking_pic": [],
    "fruit_stalk_rotten": '',
    "fruit_stalk_rotten_pic": [],
    "fruit_stalk_number": '',

  },
  "colour_info": {
    "fruit_color": [],
    "describe": "",
    "red_thorn_fruit": '',
    "brown_fruit": '',
    "whole_green_fruit": '',
    "other_fruit": '',
    "fruit_color_1": '',
    "fruit_color_1_pic": [],
    "fruit_color_2": '',
    "fruit_color_2_pic": [],
    "fruit_color_3": '',
    "fruit_color_3_pic": [],
    "fruit_color_4": '',
    "fruit_color_4_pic": [],
    "fruit_peel_type": '',
    "fruit_peel_number": '',
  },
  "shuck_info": {
    "hardness_fruit": '',//果壳硬度
    "hardness_fruit_video": [],//果壳视频
    "bear_fruit": '',
    "bear_fruit_pic": [],
    "bear_fruit_video": [],
    "bear_fruit_describe": '',//生果描述
    "dead_fruit": '',
    "dead_fruit_pic": [],
    "dead_fruit_video": [],
    "dead_fruit_describe": '',//死包描述
    "durian_fruit": '',
    "durian_fruit_pic": [],
    "durian_fruit_describe": '',//青榴莲描述
    "damage_fruit": '',
    "damage_fruit_pic": [],
    "damage_fruit_describe": '',//果壳表面损坏描述
    "wormhole_fruit": '',
    "wormhole_fruit_pic": [],
    "rotten_fruit": '',
    "rotten_fruit_pic": [],
    "other_fruit": '',
    "cleft_fruit": '',
    "cleft_fruit_pic": [],
    "maturity": [],
    "describe": "",
    "fruit_shell_type": '',
    "shuck_other_fruit": '',
    "shuck_other_fruit_pic": [],
    "cleft_fruit_low": '',
    "cleft_fruit_low_pic": [],
    "cleft_fruit_middle": '',
    "cleft_fruit_middle_pic": [],
    "cleft_fruit_high": '',
    "cleft_fruit_high_pic": [],
    "fruit_shell_in_type": '',
    "fruit_flesh_type": '',
    "fruit_flesh_rot": '',
    "fruit_flesh_rot_pic": [],
    "fruit_flesh_blight": '',
    "fruit_flesh_blight_pic": [],
    "fruit_flesh_wormy": '',
    "fruit_flesh_wormy_pic": [],
    "fruit_flesh_burning": '',
    "fruit_flesh_burning_pic": []
  },
  "flesh_info": {
    "hardness_flesh": '',//果肉硬度
    "hardness_flesh_video": [],//果肉视频
    "sugar_sampling": '',
    "sugar_sampling_type": '',
    "average_sugar": '',
    "average_sugar_pic": [],
    "flesh_color": '',
    "flesh_color_pic": [],
    "flesh_taste": '',
    "sugar_sampling1": '',
    "sugar_sampling1_pic": [],
    "sugar_sampling2": '',
    "sugar_sampling2_pic": [],
    "sugar_sampling3": '',
    "sugar_sampling3_pic": []
  },
  "other_info": {
    "inspection_video": "",//现场视频
    "inspection_report": "",
    "inspection_pic": [],//质检卡
    "inspection_scene_pic": [],//现场照片
    "inspection_process_pic": [],//过程照片
    "inspection_process_video": [],//过程视频
    "inspection_card_video": [], //质检卡视频
  }
};

function createActionsList(str) {
  return str.split('，').map(item => ({ name: item }));
}

export const fruitColorList = createActionsList('1号色，2号色，3号色，4号色，5号色');
export const maturityList = createActionsList('未熟，夹生，适中，成熟，过熟');
// export const containerTasteList = createActionsList('青草味，淡青草味(香味浓,青草味淡)，中等(香味和青草味较平均)，浓香型(榴莲香味重)');
export const fleshColorList = createActionsList('浅白色，浅黄色，黄色，深黄色');
export const fleshTasteList = createActionsList('软糯香甜，甘甜，苦甜，甜中微涩，苦');
export const hardnessFruitList = createActionsList('微软，软，微硬，硬');
export const hardnessFleshList = createActionsList('微软，软，微硬，硬');
export const containerTasteList = createActionsList('轻微香气，中等香气，强烈香气，其他');
export const formatType = 'YYYY-MM-DD HH:mm';

export function isPureNumber(str) {
  return (str !== void 0) && (str !== null) && (String(str).trim() !== '') && !isNaN(Number(str));
}

/**
 * @param {*} arg1 数字
 * @param {*} arg2 数字
 * @description 两数字相减 保持精度
 */
export const accSub = (arg1, arg2) => {
  let r1, r2, m, n;
  try { r1 = arg1.toString().split('.')[1].length; } catch (e) { r1 = 0; }
  try { r2 = arg2.toString().split('.')[1].length; } catch (e) { r2 = 0; }
  m = Math.pow(10, Math.max(r1, r2));
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
};

// const handling_opinion = ['-', '正常进行下阶段', '龙头拉走', '保险公司赔偿', '正常销售', '清关公司赔偿', '其他'];
export const handling_opinion = {
  0: '-',
  1: '正常进行下阶段',
  2: '龙头拉走',
  3: '保险公司赔偿',
  4: '正常销售',
  5: '清关公司赔偿',
  6: '其他'
};
/**
 * 通用视频上传前校验方法（适配Ant Design Upload的beforeUpload回调）
 * @param {File} file - 上传的文件对象（Upload组件自动传入）
 * @param {Object} [options] - 可选配置参数，无则使用默认值（与原方法一致）
 * @param {number} [options.maxDuration=60] - 视频最大允许时长（秒）
 * @param {string} [options.allowedType='video/mp4'] - 允许的视频格式（MIME类型）
 * @param {string} [options.typeErrorMsg] - 格式错误提示文案，无则使用默认
 * @param {string} [options.durationErrorMsg] - 时长超限提示文案，无则使用默认
 * @returns {Promise<boolean>} - 校验通过返回true，失败返回false（阻止上传）
 */
const getAudioDuration = (file) => {
  return new Promise(resolve => {
    const url = URL.createObjectURL(file);
    const audioElement = new Audio(url);
    audioElement.addEventListener("loadedmetadata", () => {
      resolve(audioElement.duration);
    });
  });
};
export const validateVideoBeforeUpload = async (file) => {
  const { type } = file;
  const isLimitTime = (await getAudioDuration(file)) <= 60;
  const isMp4 = type === 'video/mp4';
  if (!isMp4) {
    message.error('请上传mp4格式的视频!');
  }
  if (!isLimitTime) {
    message.error('视频时长不超过60s!');
  }
  return isMp4 && isLimitTime;
};
export const useHumidityLevel = (value) => {
  if (value === undefined || value === null) return { humidity_level: '', humidity_color: '' };
  if (value < 60) return { humidity_level: '低', humidity_color: 'orange' };
  if (value >= 60 && value <= 65) return { humidity_level: '正常', humidity_color: 'green' };
  if (value > 70) return { humidity_level: '高', humidity_color: 'red' };
  // 65-70% 过渡区间返回空
  return { humidity_level: '', humidity_color: '' };
};